import { AlertCircleIcon, StarIcon } from 'lucide-react';
import { errorCount, type Check } from './catalogRules';
import { plural } from '../../core/format/text';
import type { Product } from '../../core/types/catalog';

/** Of een product compleet is, en of het uitgelicht staat. Zelfde weergave in de lijst en de tabel. */
export function ProductStatus({
  product,
  checks
}: {
  product: Product;
  checks: Check[];
}) {
  const errors = errorCount(checks);
  return <span className="flex items-center gap-2 text-[12px]" data-id="element-820" data-mp="7hvh3otpuwk">
      {errors > 0 ? <span className="inline-flex items-center gap-1 text-clay" data-id="element-821" data-mp="3rflxbyhrmlnz">
          <AlertCircleIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-822" data-mp="3mn2k52mzpsjp" />
          {plural(errors, 'probleem', 'problemen')}
        </span> : checks.length > 0 ? <span className="text-muted" data-id="element-823" data-mp="iy8zdpq1kt3k">Aan te vullen</span> : <span className="text-sage" data-id="element-824" data-mp="j0lr2ullqhtt">Compleet</span>}
      {(product.bestseller || product.salonFavourite) && <>
          <StarIcon className="h-3.5 w-3.5 fill-current text-clay" strokeWidth={0} aria-hidden="true" data-id="element-825" data-mp="2xx2es2q249am" />
          <span className="sr-only" data-id="element-826" data-mp="32vlyrxl3bb0c">Uitgelicht</span>
        </>}
    </span>;
}